import shipvistaAPI from "./shipvistaAPI";

export const postContactUsEmail = (email: any) => {
  return shipvistaAPI.post(`/register/sendContactusEmail`, email);
};

export const contactUsEmail = (_data: any) => {
  return shipvistaAPI.post(`/contactusemail/sendContactusEmail`, _data);
};

export const connectWithUsEmailService = (_data: any) => {
  return shipvistaAPI.post(`/contactusemail/connectwithusemail`, _data);
};

export const sendSupportEmail = (data: any) => {
  return shipvistaAPI.post(`/contactusemail/supportEmail`, data);
};

export const sendSalesEmail = (data: any) => {
  return shipvistaAPI.post(`/contactusemail/salesEmail`, data);
};

export const partnerEmailService = (data: any) => {
  return shipvistaAPI.post(`/contactusemail/partnerEmail`, data);
};

export const becomeDeveloperService = (data: any) => {
  return shipvistaAPI.post(`/contactusemail/becomeDeveloperEmail`, data);
};

export const doNotSellInfoEmail = (data: any) => {
  return shipvistaAPI.post(`/contactusemail/doNotSellInfoEmail`, data);
};

export const shipVistaConnectEmail = (data: any) => {
  return shipvistaAPI.post(`/contactusemail/shipVistaConnectEmail`, data);
};
// export const contactUsEmail=(_data)=>{
//     return shipvistaAPI.post(`https://localhost:44368/api/contactusemail/sendContactusEmail`,_data)
// }
